import React, { useContext, useEffect, useRef, useState } from "react";

import api from "shared/infra/services/api";
import AuthContext from "shared/providers/context/AuthContext";
import openNotificationWithIcon from "shared/utils/openNotificationWithIcon";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";

import {
  Button,
  Container,
  CuponContainer,
  Discount,
  HasCouponButton,
  Input,
  InputContainer,
  LoadingIcon,
  TicketIcon,
} from "./styles";

const Coupon = () => {
  const { steps, offer, informations, coupon, setCoupon, setLoader, loader } =
    useCheckoutStepsOffersContext();

  if (steps < 1) return null;

  const { loggedUser } = useContext(AuthContext);

  const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const [renderInput, setRenderInput] = useState<Boolean>(false);
  const [isFocused, setIsFocused] = useState<Boolean>(false);

  const handleSetFocus = () => setIsFocused((prevState) => !prevState);

  const handleRenderInput = () => setRenderInput((prevState) => !prevState);

  const applyCouponRequest = async (coupon_code: string) => {
    setLoader(true);

    const requestBody = {
      group_id: offer.group.id,
      offer_id: offer.offer.id,
      code: coupon_code,
    };

    if (!loggedUser) requestBody["email"] = informations.email;

    try {
      const response = await api.post("coupon/apply", requestBody);

      setLoader(false);
      return response.data.data;
    } catch (error) {
      setLoader(false);

      const data = error.response.data;

      if (data?.code) {
        const { code } = data;

        openNotificationWithIcon(
          "error",
          "Erro ao utilizar o cupom",
          code && code[0],
        );
      }

      if (data?.message) {
        const { attrs, errors, message } = data;
        const error = !!attrs ? attrs[0] : errors?.code || message;

        if (Array.isArray(error)) {
          error.forEach((error) =>
            openNotificationWithIcon(
              "error",
              "Erro ao utilizar o cupom",
              error,
            ),
          );
        } else {
          openNotificationWithIcon("error", "Erro ao utilizar o cupom", error);
        }
      }

      console.log(error);
    }
  };

  const handleApplyCoupon = async () => {
    if (!!coupon) return setCoupon(null);

    const value = inputRef.current.value;
    const response = await applyCouponRequest(value);

    setCoupon(response);
  };

  useEffect(() => {
    if (coupon) {
      if (inputRef?.current)
        inputRef.current.value = `"${coupon?.item?.coupon_code}" aplicado`;
      return;
    }

    if (inputRef?.current) inputRef.current.value = "";
  }, [coupon]);

  const discountPercentage = (
    (coupon?.item?.coupon_discount_value * 100) /
    Number(offer.offer.price)
  ).toFixed(0);

  return (
    <Container onMouseLeave={() => setRenderInput(false)}>
      <CuponContainer>
        <HasCouponButton type="button" onClick={handleRenderInput}>
          <TicketIcon />
          Tem um cupom?
        </HasCouponButton>

        {(renderInput ||
          coupon ||
          !!inputRef.current?.value.length ||
          isFocused) && (
          <InputContainer>
            <Input
              ref={inputRef}
              readOnly={!!coupon}
              onBlur={handleSetFocus}
              onFocus={handleSetFocus}
              placeholder="Digite seu cupom"
              onKeyPress={(e) => {
                if (e.code === "Enter") {
                  e.preventDefault();
                  e.isPropagationStopped();

                  handleApplyCoupon();
                }
              }}
            />

            <Button type="button" disabled={loader} onClick={handleApplyCoupon}>
              {loader && <LoadingIcon />}
              {coupon ? "Remover" : "Aplicar"}
            </Button>
          </InputContainer>
        )}

        {coupon && <Discount>Desconto de {discountPercentage}%</Discount>}
      </CuponContainer>
    </Container>
  );
};

export default Coupon;
